import React from "react";
import { useTranslation } from "react-i18next";
import StageWorkflowsEmptyState from "@/components/shared/StageWorkflowsEmptyState";

const TRANSLATION_PREFIX = "deals.dealView.emptyWorkflows";

interface Props {
  isEmptyWorkflowsMode?: boolean;
  className?: string;
}

const EmptyState: React.FC<Props> = ({
  isEmptyWorkflowsMode = false,
  className
}) => {
  const { t } = useTranslation();

  return (
    <StageWorkflowsEmptyState
      title={t(
        `${TRANSLATION_PREFIX}.${
          isEmptyWorkflowsMode ? "emptyWorkflowsTitle" : "title"
        }`
      )}
      subtitle={t(
        `${TRANSLATION_PREFIX}.${
          isEmptyWorkflowsMode ? "emptyWorkflowsSubtitle" : "subtitle"
        }`
      )}
      className={className}
    />
  );
};

export default EmptyState;
